import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfGeraisService } from 'src/app/services/conf-gerais.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn
} from '@angular/forms';
@Component({
  selector: 'app-tmp',
  templateUrl: './tmp.component.html',
  styleUrls: ['./tmp.component.scss']
})
export class TmpComponent implements OnInit {
  issueForm?: FormGroup;
  constructor(
    private route: ActivatedRoute,
    public fb: FormBuilder,
    private configService: ConfGeraisService,
    private router: Router
  ) {
    this.issueForm = this.fb.group({
      // defina os controles do formulário aqui
      // exemplo: 'name': ['']
    });
  }
  loading: boolean = true;
  ngOnInit() {
    const hostname = window.location.hostname;
    if (hostname !== 'app.slicksell.com.br') {
      // Observa as mudanças na URL da rota ativa
      this.route.url.subscribe(urlSegments => {
        console.log('URL Segments:', urlSegments);
        if (urlSegments.length > 0) {
          const segmento = urlSegments[0].path;
          this.issueForm = this.fb.group({
            "subdomain": `${segmento}.slicksell.com.br`
          });
          const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');

          if (selectedStoreId) {
            const queryParams = this.getQueryParams(); // Obter parâmetros atualizados

            this.router.navigate([`${segmento}/p-video-player`], { queryParams: queryParams });
            this.loading = false;
          }
        }
      });
    }
  }

  private getQueryParams(): any {
    const queryStartIndex = window.location.href.indexOf('?');
    if (queryStartIndex === -1) return {}; // Sem parâmetros de consulta na URL

    const queryParamsStr = window.location.href.substring(queryStartIndex);
    const urlParams = new URLSearchParams(queryParamsStr);
    const params: any = {};

    ['slick_id', 'widget', 'utm_source', 'utm_campaign', 'utm_term', 'utm_content', 'utm_medium'].forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        params[param] = value;
        localStorage.setItem(param, value);
        this.setCookie(param, value, 30);
      }
    });

    return params;
  }



  private setCookie(name: string, value: string, days: number): void {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
}
